/* eslint-disable */
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '../../Components/ui/card'
import { Button } from '../../Components/ui/button'
import { Label } from '../../Components/ui/label'
import { Input } from '../../Components/ui/input'
import { post } from '../../http/restservice'
import env from '../../env/env'
import { ChevronDown, ChevronLeft } from 'lucide-react'
import { useModal } from '../../hooks/use-modal-store'
import { MFTimeBasedBaskets } from '../../store/MFBasketsStore'
import { useRecoilValueLoadable } from 'recoil'
import { toCurrency } from '../../utils/CurrencyUtil'
import { BASKET_SIP_MIN } from '../../constants/sips'

const InvestMoreSIP = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [amount, setAmount] = useState(Number(location?.state?.payload?.orderInvestmentAmount) || 0)
  const [amountInput, setAmountInput] = useState('0')

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')
  const { onOpen } = useModal()
  const baskets = useRecoilValueLoadable(MFTimeBasedBaskets)

  useEffect(() => {
    setAmountInput(toCurrency(Number(amount || 0)))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleAmountInputChange = (e) => {
    const raw = (e?.target?.value || '').toString().replace(/[^0-9]/g, '')
    const numeric = raw ? Number(raw) : 0
    setAmount(numeric)
    setAmountInput(toCurrency(numeric))
  }


  const universalBasketId =
    +location?.state?.basket[0]?.universalBasketId || +location?.state?.basket?.universalBasketId


  const getNewSipBreakdown = (totalAmount) => {
    const basketFunds =
      baskets?.state === 'hasValue'
        ? baskets?.contents?.data?.filter((plan) => plan.universalBasketId === universalBasketId) ||
        []
        : []

    const filteredBasketFunds = basketFunds?.filter((fund) => fund.weightage > 0)
      .map((fund) => ({
        ...fund,
        investmentAmount: (totalAmount / 100) * fund.weightage,
        customerBasketInvestmentId:
          location?.state?.basket[0]?.customerBasketInvestmentId ||
          location?.state?.basket?.customerBasketInvestmentId,
        customerBasketName:
          location?.state?.basket[0]?.customerBasketName ||
          location?.state?.basket?.customerBasketName,
      }))

    return filteredBasketFunds
  }







  const handleSubmit = async () => {
    setError('')

    // Basic validation
    if (!amount || isNaN(Number(amount)) || Number(amount) <= 0) {
      setError('Please enter a valid investment amount')
      return
    }

    const sipBreakdown = getNewSipBreakdown(amount)



    const url = `${env.API_URL}adminservice/api/actionPlan/subsequentOneTimeOrder`

    const payload = {
      clientCode: location?.state?.clientCode,
      sipOrderInvestmentAmount: amount,
      sipOrderInvestmentBreakdown: sipBreakdown,
      customerBasketInvestmentId:
        location?.state?.basket[0]?.customerBasketInvestmentId ||
        location?.state?.basket?.customerBasketInvestmentId,
    }

    setIsLoading(true)

    const response = await post(url, payload)

    setIsLoading(false)

    if (
      response?.status === 'SUCCESS' &&
      response?.message?.includes('Order created successfully')
    ) {
      onOpen('openAdminPopup', {
        title: 'Order Created!',
        message: 'Your order has been successfully created.',
        severity: 'success',
      })
    } else {
      onOpen('openAdminPopup', {
        title: 'Order Failed!',
        message:
          'There was an issue creating your order. Please try again later or contact support if the issue persists.',
        severity: 'error',
      })
    }
  }

  return (
    <>
      <ChevronLeft onClick={() => navigate(-1)} className='cursor-pointer' />
      <div className='container flex items-center justify-center min-h-[70vh] py-12'>
        <Card className='w-full max-w-xl'>
          <CardHeader>
            <CardTitle className='text-2xl font-bold'>
              {location?.state?.basket[0]?.customerBasketName ||
                location?.state?.basket?.customerBasketName}{' '}
              - (SIP)
            </CardTitle>
            <CardDescription>
              Enter the amount you would like to invest in your portfolio
            </CardDescription>
          </CardHeader>

          <CardContent>
            <div className='space-y-4'>
              <div className='space-y-2'>
                <Label htmlFor='amount' className='font-semibold'>
                  SIP Investment Amount
                </Label>
                <div className='relative'>
                  <Input
                    startAdornment='₹'
                    id='amount'
                    type='text'
                    placeholder='0'
                    className='pl-10'
                    value={amountInput}
                    onChange={handleAmountInputChange}
                  />
                </div>
                {error && <p className='text-sm font-medium text-red-500'>{error}</p>}
              </div>

              <div className='flex justify-center items-center'>
                <Button
                  variant='link'
                  size='simple'
                  className='text-primary-500 p-0 border-b border-dashed border-primary-500 rounded-none hover:no-underline'
                  disabled={amount <= 0}
                  onClick={(e) => {
                    e.stopPropagation(),
                      onOpen('OpenAdminMFBreakdown', {
                        constituents: getNewSipBreakdown(amount),
                        amount: amount,
                      })
                  }}
                >
                  View detailed breakdown
                  <ChevronDown className='h-4 w-4 ml-1' />
                </Button>
              </div>

              <div>
                <p className='text-sm text-error-500 text-center'>
                  Minimum SIP amount is ₹ {toCurrency(BASKET_SIP_MIN[universalBasketId])}
                </p>
              </div>


              {/* <div className='my-12 max-w-3xl'>
                <Label className='text-sm text-black-300'>
                  Select SIP Date{' '}
                  <span className='text-black-400'>
                    (Next Instalment - {addNumberSuffix(+nextSipDay)} {monthNames[nextSipMonth - 1]}{' '}
                    {nextSipYear})
                  </span>
                </Label>
                <Popover>
                  <PopoverTrigger asChild>
                    <Button
                      variant={'outline'}
                      className='pl-3 font-normal border-none bg-primary-50 rounded-lg w-full flex justify-between max-w-3xl mx-auto'
                    >
                      <span className='text-primary-500 flex items-center gap-x-2'>
                        <CalendarIcon className='ml-auto h-4 w-4 opacity-50' />
                        {addNumberSuffix(+selectedDay)} of every month
                      </span>

                      <Pen className='h-4 w-4 text-primary-500' />
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent className='p-0 w-auto rounded-full' align='center' side='top'>
                    <div className='flex gap-x-2 p-2'>
                      {sipDates.map((day, index) => (
                        <Button
                          key={(day + index).toString()}
                          className={`h-8 w-8 rounded-full inline-block ${
                            selectedDay !== +day
                              ? 'bg-white border border-primary-50 text-black-400 hover:bg-primary-50'
                              : 'text-white'
                          }`}
                          size='simple'
                          onClick={() => setSelectedDay(+day)}
                        >
                          {day}
                        </Button>
                      ))}
                    </div>
                  </PopoverContent>
                </Popover>
              </div> */}
            </div>
          </CardContent>

          <CardFooter>
            <Button
              onClick={handleSubmit}
              type='submit'
              className='w-full disabled:bg-primary-300'
              disabled={isLoading || amount <= 0}
            >
              {isLoading ? 'Processing...' : 'Continue'}
            </Button>
          </CardFooter>
        </Card>
      </div>
    </>
  )
}

export default InvestMoreSIP
